/*!
 * Copyright (C) Octillion Media LLC 2019
 * All Rights Reserved.
 */
export const namespaced = true;

export const state = {
  selectedLocations: []
}

export const mutations = {
  SET_SELECTED_LOCATION(state, locations) {
    state.selectedLocations = locations;
  },
  ADD_SELECTED_LOCATION(state, location) {
    const exists = state.selectedLocations.some(loc => loc.id === location.id && loc.geo_type === location.geo_type);
    if (!exists) {
      state.selectedLocations.push(location);
    }
  },
  REMOVE_SELECTED_LOCATION(state, locationValue) {
    state.selectedLocations = state.selectedLocations.filter(
      loc => !(loc.code === locationValue.code && loc.geo_type === locationValue.geo_type)
    );
  },
  CLEAR_LOCATION(state) {
    state.selectedLocations = [];
  }
}

export const actions = {
  addSelectedLocation({ commit }, payload) {
    commit('ADD_SELECTED_LOCATION', payload);
  },
  setSelectedLocation({ commit }, payload) {
    commit('SET_SELECTED_LOCATION', payload);
  },
  removeSelectedLocation({ commit }, payload) {
    commit('REMOVE_SELECTED_LOCATION', payload);
  },
  clearLocationSelected({ commit }) {
    commit('CLEAR_LOCATION')
  }
}
